$(".chosen-select").chosen({
    disable_search_threshold: 12,
    width: '100%'
});

let frameMsg = null;

jQuery(document).ready(function ($) {
    // The following code is a merge of frameMsg.js and resizeHelper.js from the ogr-framework.
    // The code from frameMsg.js is saved as the frameMsk object creation function
    // and the resizeHelper.js file is saved as the frameMsg.resizeHelper object creation function.
	frameMsg = (function ()
	{
        var eventMethod = (window.addEventListener) ? 'addEventListener' : 'attachEvent',
            messageEvent = (window.ogrMsgEvent) ? 'ogrMsgEvent' : (eventMethod === 'attachEvent') ? 'onmessage' : 'message',
            eventer = window[eventMethod],
            isReady = false,
            id,
            source,
            origin,
            currentHeight,
            isUpdating = false,
            body = $('body'),
            resizeHelper = (function () {
                var resizes = [],
                    resizeHelper,
                    mediaqueryHelper,
                    media = 'desktop',
                    device = 'desktop';

                // read media-query state
                mediaqueryHelper = function () {
                    var newMedia,
                        newDevice;

                    // try reading css values
                    try {
                        newMedia = window.getComputedStyle(document.body, ':after').getPropertyValue('content');
                        newDevice = window.getComputedStyle(document.body, ':before').getPropertyValue('content');
                        // replace characters that browsers are rendering into the strings
                        newMedia = newMedia.replace(/"|'/gi, '');
                        newDevice = newDevice.replace(/"|'/gi, '');
                    } catch (e) {
                        newMedia = 'desktop';
                        newDevice = 'desktop';
                    }

                    // fallback or set new values
                    media = (newMedia.length) ? newMedia : 'desktop';
                    device = (newDevice.length) ? newDevice : 'desktop';
                };
                mediaqueryHelper();
                resizes.push(mediaqueryHelper);

                resizeHelper = function () {
                    var i = 0,
                        count = resizes.length;

                    for (; i < count; i++) {
                        resizes[i].call();
                    }
                };

                $(window).on('resize', resizeHelper);

                return {
                    add: function (f) {
                        if (typeof f === 'function') {
                            resizes.push(f);
                            return resizes.length - 1;
                        }
                        return -1;
                    },

                    remove: function (f) {
                        var i = 0,
                            l = resizes.length;

                        for (; i < l; i++) {
                            if (resizes[i] === f) {
                                resizes[i] = $.noop;
                                break;
                            }
                        }
                    },

                    getDevice: function () {
                        return device;
                    },

                    getMedia: function () {
                        return media;
                    },

                    match: function (values) {
                        var type = $.type(values),
                            count = values.length,
                            found = false,
                            i;

                        if (type === 'string') {
                            found = (media === values);
                        }

                        if (type === 'array') {
                            for (i = 0; i < count; i++) {
                                if (media === values[i]) {
                                    found = true;
                                    break;
                                }
                            }
                        }

                        return found;
                    }

                };
            })();

        // get the value for box-shadow
        function getBoxShadow($el) {

            var boxShadow = $el.css('box-shadow'),
                result = 0,
                i = 0;

            // none or inset box-shadow are not relevant
            if (boxShadow === 'none' || boxShadow.search(/inset/ig) > -1) {
                return result;
            }

            // remove color and units
            boxShadow = boxShadow
                .replace(/rgb(a){0,1}\([\d\s,\.]*\)/ig, '')
                .replace(/px/ig, '');

            // remove whitespace around all and split into array
            boxShadow = $.trim(boxShadow).split(' ');

            // parse all values to numbers
            for (; i < boxShadow.length; i++) {
                boxShadow[i] = parseInt(boxShadow[i], 10);
            }

            // test the result
            if (boxShadow.length !== 4 || isNaN(boxShadow[0]) || isNaN(boxShadow[1]) || isNaN(boxShadow[2]) || isNaN(boxShadow[3])) {
                return result;
            }

            // calculate the result
            result = boxShadow[2] + boxShadow[3];

            return result;
        }

        // calculate the height of the document
        function calcHeight() {
            var maxhabs = 0,
                // add one pixel because FF cuts of decimal places so the number is not rounded up
                maxhrel = Math.ceil(document.body.offsetHeight) + 1,
                atotoffset = 0;

            // get all elements
            $.each(body.find('*:not(script)'), function () {
                var $el = $(this),
                    elOffset,
                    offsetTop,
                    offsetHeight,
                    boxShadow;

                if ($el.is(':visible') && $el.css('position') === 'absolute') {
                    offsetTop = $el.offset().top;

                    if (typeof offsetTop !== 'undefined') {
                        boxShadow = getBoxShadow($el);
                        offsetHeight = $el.context.offsetHeight;
                        elOffset = offsetTop + offsetHeight + boxShadow;

                        if (atotoffset < elOffset) {
                            atotoffset = elOffset;
                        }
                    }
                }
            });

            // absolute element offset position from the top
            maxhabs = Math.ceil(atotoffset);

            return (maxhrel > maxhabs) ? maxhrel : maxhabs;
        }

        // listen to custom postMessage-events
        eventer(messageEvent, function (event) {

            // data string, which is send by the parent-website, e.g. "height-2"
            var data = (window.iframeEvent) ? window.iframeEvent.data : event.data;

            // if no data return
            if (!data || data.length === 0) {
                return;
            }

            // convert to an array
            data = data.split('-');

            // test if the array has two entries
            if (data.length !== 2) {
                return;
            }

            // the first entry has to be the height
            if (data[0] !== 'height') {
                return;
            }

            // the second entry has to be a number
            // this is the reference id for communication
            id = parseInt(data[1], 10);
            if (isNaN(id)) {
                id = undefined;
                return;
            }

            // save the source and orgin for later use
            source = (window.iframeEvent) ? window.iframeEvent.source : event.source;
            origin = (window.iframeEvent) ? window.iframeEvent.origin : event.origin;

            // all correct
            isReady = true;

            // send initial height of the body, without scrolling
            sendPostMessage(calcHeight(), false);
        }, false);

        // format: id-height-scrollposition (e.g. 2-300-0)
        function sendPostMessage(height, scrollposition) {
            if (!isReady) {
                return;
            }

            // save current height
            if (typeof height === 'number') {
                currentHeight = height;
            }

            // concat string
            var sendString = id + '-' + currentHeight;

            // add scroll if it is a number
            if (typeof scrollposition === 'number') {
                sendString += '-' + scrollposition;
            }

            // send
            source.postMessage(sendString, origin);
        }

        if (window.iframeEvent && window.ogrMsgEvent) {
            window.dispatchEvent(window.ogrMsgEvent);
        }

        function update() {
            if (!isUpdating) {
                isUpdating = true;

                var newHeight = calcHeight();

                if (newHeight !== currentHeight) {
                    sendPostMessage(newHeight, null);
                }

                isUpdating = false;
            }
        }

        // listen for resize, module creation and update calls
        resizeHelper.add(update);

        return {

            // calculates the height of the document inclusive absolute positioned elements
            calcDocumentHeight: function () {
                return calcHeight();
            },

            // set new height and scrollposition
            send: function (height, scrollposition) {
                sendPostMessage(height, scrollposition);
            },

            // updates the iframe height
            height: function (height) {
                sendPostMessage(height, null);
            },

            // scroll to a specific position
            scrollTo: function (scrollposition) {
                sendPostMessage(null, scrollposition);
            }
        };
    })();
    frameMsg.height(frameMsg.calcDocumentHeight());
});